import React from 'react';
import PropTypes from 'prop-types';
import Translate from 'client/components/translate';
import { Link } from 'react-router';

export const InteractiveListItemShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  titleKey: PropTypes.string, // if titleKey is defined, it will use Translate component
  subtitleKey: PropTypes.string, // if subtitleKey is defined, it will use Translate component
  illustration: PropTypes.string.isRequired,
});

const propTypes = {
  item: InteractiveListItemShape.isRequired,
  clickHandler: PropTypes.func,
};

const defaultProps = {
  clickHandler: () => {},
};

const InteractiveListItem = ({ item, clickHandler }) => {
  const rightContent = (
    <div>
      <div className="title grey-2-color">
        {item.titleKey ? <Translate path={item.titleKey} /> : item.title}
      </div>
      {(item.subtitle || item.subtitleKey) && (
        <div className="subtitle">
          {item.subtitleKey ? <Translate path={item.subtitleKey} /> : item.subtitle}
        </div>
      )}
    </div>
  );

  return (
    <Link className="flex-row selection-list-item" onClick={e => clickHandler(e)} to={item.url}>
      {rightContent}
    </Link>
  );
};

InteractiveListItem.propTypes = propTypes;
InteractiveListItem.defaultProps = defaultProps;

export default InteractiveListItem;
